import React from "react";
import AuthFooter from "./AuthFooter";
import DefaultFooter from "./DefaultFooter";

const Footer = ({ authenticated }) => {
  return authenticated ? <></> : <DefaultFooter />;
};

export default Footer;
